export const ACTIONS = {
  CLOSE_ALERT_GS: "CLOSE_ALERT_GS",
  SHOW_ALERT_GS: "SHOW_ALERT_GS",
  SET_NOTIF: "SET_NOTIF",
  SET_SHOW_NOTIF: "SET_SHOW_NOTIF",
  SET_NOTIF_DEPOSIT: "SET_NOTIF_DEPOSIT",
  SET_NOTIF_COPIED: "SET_NOTIF_COPIED",
};
